export default __webpack_public_path__ + "static/media/74.983fbd9c.png";